<template>
  <div>
    <maritimeService :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency" />
    <v-container>
      <v-row>
        <v-col sm="12" md="7" lg="7" class="mt-sm-20">
          <br />
          <v-row> <v-img src="@/assets/EcoHarbor.jpg" class="image" /></v-row>
          <v-row class="pt-4">
            <h1>Supplier Management and Risk Assessment System with Integrated ESG Questionnaire</h1>
            <br />
            <p class="supplier-class">
              At Maritech Software, we're proud to introduce our Supplier Management and Risk Assessment System – a comprehensive solution designed to streamline your supplier interactions, assess risks effectively, and enhance sustainability practices through an integrated ESG (Environmental, Social, and Governance) questionnaire. Our platform empowers you to create multiple ESG questionnaire forms effortlessly and send them to your suppliers, fostering transparency and responsible business practices across your supply chain.
            </p>
            <h1>EcoHarbor - ESG enabled Supplier Management</h1>
            <br /><br />
            <p class="supplier-class">
              <strong>Product Name: EcoHarbor Insights</strong>
              <br />
              Welcome to EcoHarbor Insights, the definitive solution for the
              maritime industry's sustainability journey. Our cutting-edge
              supplier portal revolutionizes ESG management by seamlessly
              integrating diverse data sources, empowering companies to drive
              environmental sustainability, governance, and social
              responsibility in a tailored, efficient manner.
              <br /><br />
              <strong>Unlock a New Era of ESG Excellence</strong>
              <br />
              EcoHarbor Insights is more than a portal; it's your strategic partner in navigating the complexities of
              environmental sustainability governance. With unparalleled access to a diverse array of third-party vendors,
              our platform aggregates and customizes data to precisely match your company's unique requirements.
              <br /><br />
              <strong>Features & Benefits:</strong>
            <ul>
              <li>
                <strong>Comprehensive Data Integration:</strong> Seamlessly gather and synthesize data from various
                vendors for a holistic view of your ESG performance.
              </li>
              <li>
                <strong>Customized Dashboard:</strong> Tailor the dashboard to your company's specific needs, visualizing
                key metrics and performance indicators in real-time.
              </li>
              <li>
                <strong>Actionable Insights:</strong> Make informed decisions with actionable insights derived from data
                analysis, driving sustainable practices and enhancing governance.
              </li>
              <li>
                <strong>ESG Questionnaire Integration:</strong> Seamlessly create and customize ESG questionnaire forms tailored to your business requirements. Engage suppliers in sustainability initiatives and track progress effortlessly.
              </li>
              <li>
                <strong>Supplier Risk Management:</strong> Utilize our checklist-based module to evaluate supplier risk factors comprehensively. Identify potential risks, mitigate vulnerabilities, and ensure robust supplier relationships.
              </li>
              <li>
                <strong>ERP System Integration:</strong> Our system seamlessly integrates with leading ERP systems including Shipnet, IMOS Netsuite, ensuring smooth data synchronization and operational efficiency.
              </li>
              <li>
                <strong>Single Sign-On (SSO) Enabled:</strong> Enjoy enhanced security and convenience with Single Sign-On functionality, allowing users to access the platform using their existing credentials.
              </li>
              <li>
                <strong>PowerBI Integration:</strong> Gain actionable insights and make informed decisions with PowerBI integration. Visualize data, track performance metrics, and uncover valuable trends to drive business growth.
              </li>
              <li>
                <strong>Flexible Hosting Options:</strong> Choose between self-hosting or managed hosting options based on your preferences and IT infrastructure requirements, ensuring optimal performance and scalability.
              </li>
              <li>
                <strong>Unlimited Supplier/User License:</strong> Enjoy unlimited flexibility with our pricing model. Empower your entire team and collaborate seamlessly with suppliers without worrying about license limitations.
              </li>
              <li>
                <strong>Affordable Pricing:</strong> Avail all these powerful features and exceptional support for just $250 per month. Experience unparalleled value without breaking the bank.
              </li>
            </ul>
            <br /><br />
            <strong>Why Choose EcoHarbor Insights?</strong>
            <br />
            Our commitment extends beyond providing a platform; we're dedicated to empowering the maritime industry's
            sustainability efforts. With user-friendly functionality and unparalleled customization options, EcoHarbor
            Insights is your catalyst for proactive ESG management.
            <br /><br />
            <strong>Join the ESG Revolution</strong>
            <br/>
            Embark on a journey towards a more sustainable future. Empower your company with EcoHarbor Insights and chart a course toward responsible environmental stewardship while enhancing governance practices.
            </p>
            <p class="supplier-class">
              <strong>Private Cloud Deployment for Enhanced Security</strong>
              <br/>
              At EcoHarbor Insights, we understand the paramount importance of data security and compliance. That's why we offer a private cloud deployment option, allowing your valuable data to remain within your IT landscape. This ensures utmost compliance adherence and enhances security protocols, providing peace of mind while leveraging our powerful platform.
            <br /><br />
            <P><strong>Why Choose Us?</strong>
              <br/>
              At Maritech Software, we're committed to delivering innovative solutions that empower businesses to thrive sustainably. Our Supplier Management and Risk Assessment System go beyond traditional approaches, offering a holistic platform to manage supplier relationships, evaluate risks, drive ESG initiatives, and unlock growth opportunities.
            </P>
            <strong>Get Started Today</strong>
            <br/>
            Take the first step towards transforming your sustainability journey. Request a demo or get in touch with our team to explore how EcoHarbor Insights can elevate your ESG strategy.
            <br /><br />
            Feel free to adjust and personalize the content to better suit your brand voice and specifics of your product.
            <br />
            Join leading organizations worldwide in transforming supplier management and risk assessment while advancing sustainability goals. Contact us now to schedule a demo and witness the difference firsthand.
            <P>
              <br/>
              Maritech Software - Empowering Sustainable Supply Chains, Together.
            </P>

            </p>
          </v-row>
        </v-col>
        <v-col sm="12" md="5" lg="5">
          <base-request />
        </v-col>
      </v-row>
    </v-container>
    <div class="text-center">
      "A one-size-fits-all approach is not effective for either shoes or
      software. Both need to be tailored to the individual user or business to
      be truly effective."
    </div>
  </div>
</template>
<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "EcoHarbor - ESG enabled Supplier Management";
  }
};
</script>

<style scoped>
.supplier-class {
  text-align: justify;
}

h1 {
  font-size: 30px;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}</style>
